module.exports = __webpack_public_path__ + "media/de_de_s3_Siegfrid.66e3b557.mp3";